module.exports = __webpack_public_path__ + "media/images/home/icon-close-white-c9b936a8442b696791f89b7f107ea027.svg";